import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// Import CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";
import "../styles/textStyles.css";
import "../styles/buttonStyles.css";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutSessionId = urlParams.get("session_id");

  useEffect(() => {
    const retrieveSession = async () => {
      if (checkoutSessionId) {
        try {
          // Update this URL to the endpoint of your deployed Google Cloud Function
          const cloudFunctionURL =
            "https://europe-west2-motics-consultations.cloudfunctions.net/retrieve_stripe_session";

          await axios.post(cloudFunctionURL, {
            sessionId: checkoutSessionId,
          });

          console.log("User account updated at Stripe checkout success.");
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } catch (error) {
          console.error("Error retrieving session: ", error);
          // Handle the error appropriately
        }
      }
    };

    retrieveSession();
  }, [checkoutSessionId, navigate]);

  return (
    <div className="box-sizing-default auth-action-container">
      <h2>Thank you for subscribing to Motics Copilot's free trial!</h2>
      <h3>You can now sign into your account. Redirecting you now...</h3>
    </div>
  );
};

export default SubscriptionSuccess;
